import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";
const adminToken = secureStorage.getItem("adminToken");

export const addBlogCategory = (FormData, setFormData, setCategoryData) => {
  axiosInstance
    .post("/blog/category/add", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Category added successfully") {
        toast.success("Category added");
        setFormData({
          category_name: "",
          parent_Id: "",
          parent_category: "",
          status: 1,
        });
        viewBlogCategory(setCategoryData);
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};

export const viewBlogCategory = (setCategoryData) => {
  axiosInstance
    .get("/blog/category/all", {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setCategoryData(res.data.data);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const UpdateBlogCategory = (FormData, setFormData, setCategoryData) => {
  axiosInstance
    .put("/blog/category/update", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Category updated successfully") {
        toast.success("Category updated");
        setFormData({
          category_name: "",
          parent_Id: "",
          parent_category: "",
          status: 1,
        });
        viewBlogCategory(setCategoryData);
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};
export const DeleteBlogCategory = (id, setCategoryData) => {
  axiosInstance
    .delete(
      "/blog/category/delete",
      {
        data: { id: id },
      },
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      if (res.data.message === "Category deleted successfully") {
        toast.success("Category deleted");

        viewBlogCategory(setCategoryData);
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};

export const addBlog = (FormData, setFormData, navigate) => {
  axiosInstance
    .post("/blog/add", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Blog added successfully") {
        toast.success("Blog added");
        setFormData({
          blogTitle: "",
          body: "",
          featuredImage: "",
          categoryId: "",
          status: 1,
          created_by: "",
        });
        navigate("/admin/blogs");
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};

export const blogList = (setBlogData, setPaginationData, Page, Limit) => {
  axiosInstance
    .get(`/blog/all?page=${Page}&limit=${Limit}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setBlogData(res.data.data);
      setPaginationData(res.data.totalPages);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const viewSingleBlog = (id, setFormData, setContent, setTags) => {
  axiosInstance
    .get(`/blog/${id}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setFormData({
        id: res.data.data.id,
        blogTitle: res.data.data.blogTitle,
        body: res.data.data.body,
        categoryId: res.data.data.categoryId,
        featuredImage: res.data.data.featuredImage,
        status: res.data.data.status,
        created_by: res.data.data.created_by,
        createdAt: res.data.data.createdAt,
      });
      setContent(res.data.data.body);
      setTags(res.data.data.tags || []);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const updateBlog = (FormData, navigate) => {
  axiosInstance
    .put("/blog/update", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Blog updated successfully") {
        toast.success("Blog updated");
        navigate("/admin/blogs");
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};

export const deleteBlog = (setBlogData, setPaginationData, Page, Limit, id) => {
  axiosInstance
    .delete(
      "/blog/delete",
      {
        data: { id: id },
      },
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      if (res.data.message === "Blog deleted successfully") {
        toast.success("Blog deleted");
        blogList(setBlogData, setPaginationData, Page, Limit);
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};
export const relatedBlogs = (setRelatedBlogData, categoryId) => {
  axiosInstance
    .get(`/blog/related/${categoryId}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setRelatedBlogData(res.data.data);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
